import { PageTitle } from '_metronic/layout/core'

import TabsButtonGroup from 'Presentation/Components/Tabs/ButtonGroup'
import Select from 'react-select'
import FormGenerator from 'Presentation/Components/Form/FormGenerator'

import useViewModel from './ViewModel'
import clsx from 'clsx'
import { isMobileDevice } from '_metronic/assets/ts/_utils'
import { TABS } from '../Config'

const UserProfile: React.FC = () => {
	const {
		companyName,
		currentTab,
		onChangeTab,
		formState,
		onChange,
		onSubmitEmail,
		onSubmitPassword,
		showOldPassword,
		showNewPassword,
		showConfirmPassword,
		onChangeShowPassword,
	} = useViewModel()
	const isHorizontal = isMobileDevice()

	return (
		<ViewPageTitle companyName={companyName}>
			<div className="row gy-5">
				<div className="col-12 d-none d-xl-block">
					<TabsButtonGroup
						manualActiveTab={currentTab}
						changeTab={onChangeTab}
						tabNames={TABS.map(tab => tab.tabName)}
						tabContents={[<></>]}
					/>
				</div>

				<div className="col-12 d-xl-none">
					<Select
						isSearchable={false}
						options={TABS.map((tab, idx) => ({ value: idx, label: tab.tabName }))}
						value={{ label: TABS.find((_, idx) => idx === currentTab)?.tabName }}
						styles={{
							control: (baseStyles, state) => ({
								...baseStyles,
								border: '1px solid #e1e3ea',
								height: 40,
							}),
							menu: (baseStyles, state) => ({
								...baseStyles,
								zIndex: 9999,
							}),
						}}
						onChange={(selected: any) => {
							if (selected !== null) onChangeTab(Number(selected?.value))
						}}
					/>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-0">
							<div className="d-flex flex-row align-items-center justify-content-between w-100 mt-5">
								{/* Title */}
								<div>
									<h2 className="text-kumopack-grey-900 fw-bold">อีเมลผู้ใช้งาน</h2>
									<div className="text-kumopack-grey-600">
										Update your photo and personal details here.
									</div>
								</div>
							</div>
						</div>
						<div className="card-body pt-0">
							<hr className="mt-2" />

							<FormGenerator
								formKey="email"
								inputType="plain"
								label="อีเมลที่เข้าใช้สู่ระบบ"
								containerClassName="mt-10 mb-5"
								isHorizontal={isHorizontal}
								tooltip="อีเมลที่เข้าใช้สู่ระบบ"
								value={formState.email}
								onChange={e => onChange('email', e.target.value)}
							/>
						</div>
						<div className="card-footer text-end">
							<button
								onClick={onSubmitEmail}
								className={clsx(
									'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
									{
										'w-200px': !isMobileDevice(),
										'w-sm-100': isMobileDevice(),
									}
								)}>
								บันทึก
							</button>
						</div>
					</div>
				</div>

				<div className="col-12">
					<div className="card border border-kumopack-grey-200">
						<div className="card-header border-0">
							<div className="d-flex flex-row align-items-center justify-content-between w-100 mt-5">
								{/* Title */}
								<div>
									<h2 className="text-kumopack-grey-900 fw-bold">รหัสผ่าน</h2>
									<div className="text-kumopack-grey-600">
										Update your photo and personal details here.
									</div>
								</div>
							</div>
						</div>
						<div className="card-body pt-0">
							<hr className="mt-2" />

							<FormGenerator
								formKey="old_password"
								inputType="plain"
								type={showOldPassword ? 'text' : 'password'}
								label="Old Password"
								placeholder="••••••••"
								additionalClassName="position-relative"
								additionalLabelCom={<span className="required" />}
								additionalComInput={
									<span
										className={clsx(
											'btn btn-sm btn-icon btn-active-secondary position-absolute translate-middle top-50 end-0 me-n2'
										)}
										onClick={() => onChangeShowPassword('oldPassword')}>
										<img
											src={
												showOldPassword
													? '/media/icons/kumopack/eye-grey.svg'
													: '/media/icons/kumopack/eye-off-grey.svg'
											}
											alt="Eye Off Grey"
											width={17}
										/>
									</span>
								}
								containerClassName="my-10"
								isHorizontal={!isMobileDevice()}
								value={formState.oldPassword}
								onChange={e => onChange('oldPassword', e.target.value)}
							/>

							<FormGenerator
								formKey="new_password"
								inputType="plain"
								type={showNewPassword ? 'text' : 'password'}
								label="New Password"
								placeholder="••••••••"
								additionalClassName="position-relative"
								additionalLabelCom={<span className="required" />}
								messageUnderBox="Ensure your password is a minimum of 8 characters long, includes at least 1 uppercase and 1 lowercase letter, 1 special character, and 1 number for enhanced security."
								additionalComInput={
									<span
										className="btn btn-sm btn-icon btn-active-secondary position-absolute translate-middle top-25 end-0 me-n2"
										onClick={() => onChangeShowPassword('newPassword')}>
										<img
											src={
												showNewPassword
													? '/media/icons/kumopack/eye-grey.svg'
													: '/media/icons/kumopack/eye-off-grey.svg'
											}
											alt="Eye Off Grey"
											width={17}
										/>
									</span>
								}
								containerClassName={'mb-10'}
								isHorizontal={!isMobileDevice()}
								value={formState.newPassword}
								onChange={e => onChange('newPassword', e.target.value)}
							/>
							<FormGenerator
								formKey="confirm_password"
								inputType="plain"
								type={showConfirmPassword ? 'text' : 'password'}
								label="Confirm Password"
								placeholder="••••••••"
								additionalClassName="position-relative"
								additionalLabelCom={<span className="required" />}
								messageUnderBox="Ensure your password is a minimum of 8 characters long, includes at least 1 uppercase and 1 lowercase letter, 1 special character, and 1 number for enhanced security."
								additionalComInput={
									<span
										className="btn btn-sm btn-icon btn-active-secondary position-absolute translate-middle top-25 end-0 me-n2"
										onClick={() => onChangeShowPassword('confirmPassword')}>
										<img
											src={
												showConfirmPassword
													? '/media/icons/kumopack/eye-grey.svg'
													: '/media/icons/kumopack/eye-off-grey.svg'
											}
											alt="Eye Off Grey"
											width={17}
										/>
									</span>
								}
								containerClassName="mb-10"
								isHorizontal={!isMobileDevice()}
								value={formState.confirmPassword}
								onChange={e => onChange('confirmPassword', e.target.value)}
							/>
						</div>
						<div className="card-footer text-end">
							<button
								onClick={onSubmitPassword}
								className={clsx(
									'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white fw-bold',
									{
										'w-200px': !isMobileDevice(),
										'w-sm-100': isMobileDevice(),
									}
								)}>
								บันทึก
							</button>
						</div>
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

/////////////////////
// View Page Title //
/////////////////////

const ViewPageTitle: React.FC<{ children: React.ReactNode; companyName: string }> = ({
	children,
	companyName,
}) => {
	return (
		<>
			<PageTitle
				breadcrumbs={[
					{
						title: 'My Account',
						path: '/profile',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'My Profile',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				{companyName}
			</PageTitle>

			{children}
		</>
	)
}

export default UserProfile
